var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Storefront",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-storefront","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="160" height="8" x="45" y="23"/>
  <rect width="24.3" height="8" x="133.8" y="135.3" transform="matrix(0.7012 -0.713 0.713 0.7012 -55.6632 145.7103)"/>
  <rect width="51" height="8" x="136.4" y="147.9" transform="matrix(0.7058 -0.7084 0.7084 0.7058 -59.9895 159.4118)"/>
  <rect width="8" height="24" x="172.5" y="153.8" transform="matrix(-0.7033 -0.7109 0.7109 -0.7033 182.7199 407.7907)"/>
  <path d="M65 175h20v-39H65v39zm8-31h4v23h-4v-23z"/>
  <path d="M224 117.5c7.1-1.5 18.7-6.7 20.6-24.5h5.9L215.4 7H35.6L0 93h5.5c2 18.6 14.5 23.5 21.5 24.7V210H5v32h242v-32h-23v-92.5M105 210v-99.8c4.4 4.6 10.5 8 18.6 8 1.9 0 17.6-.4 23.8-15.8 4.2 7.8 11.9 15.6 24.2 15.6h.1c2.2 0 16.8-.5 23.2-14.6 4 6.9 10.7 13.6 21.1 14.6v92H105zM59.3 93h36.1c-2.2 17.2-16.1 17.2-17.7 17.2h-.2c-11.3 0-16.6-9.3-18.8-15 .3-.8.5-1.5.6-2.2zm44.8 0h37.4c-2.2 17.2-16.1 17.2-17.7 17.2h-.2c-12.9 0-17.9-12.2-19.5-17.2zm48 0h37.4c-2.2 17.2-16.1 17.2-17.7 17.2h-.2c-12.9-.1-17.9-12.1-19.5-17.2zm66.7 17.2h-.2c-12.9 0-18-12.1-19.5-17.2h37.4c-2.2 17.2-16.1 17.2-17.7 17.2zM41 15h169l28.6 70H12l29-70zM13.6 93h36.1c.1.7.3 1.4.6 2.2-2.2 5.7-7.5 15-18.7 15h-.2c-.7 0-15.5.4-17.8-17.2zM35 117.9c9.3-1.2 15.6-7 19.5-13.3 4.4 7.1 11.8 13.6 23 13.6 1.5 0 12.2-.2 19.5-8.7V210H35v-92.1zM239 234H13v-16h226v16z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/storefront.svg